import React from "react";
import WhyChooseUs from "./components/WhyChooseUs.jsx";
import Achievements from "./components/Achievements.jsx";
import Products from "./components/Products.jsx";
import Hero2 from "./components/Hero2.jsx";
import HomeFirst from "./components/HomeFirst.jsx";
// import { medialUrl } from "../EndPoints.jsx";
import OurCustomers from "../SisterConcern/components/OurCustomers.jsx";

import VertbaudetLogo from "../assets/customer-logos/vertbaudet.png";
import SfreaLogo from "../assets/customer-logos/sfera.png";
import AldiLogo from "../assets/customer-logos/aldi.png";
import MangoLogo from "../assets/customer-logos/mango.png";
import GemoLogo from "../assets/customer-logos/gemo.png";
import IdentityLogo from "../assets/customer-logos/identity.png";
import InterSunLogo from "../assets/customer-logos/inter-sun AS.png";
import NewLookLogo from "../assets/customer-logos/new-look.png";
import LaHalleLogo from "../assets/customer-logos/la-halle.png";
import BelBoLogo from "../assets/customer-logos/bel-bo.png";
import SportsGroupDenmarkLogo from "../assets/customer-logos/sports-group-denmark.png";
import ChiccoLogo from "../assets/customer-logos/chicco.png";
import SergentMajorLogo from "../assets/customer-logos/sergent-major.png";
import TapeALoeilLogo from "../assets/customer-logos/tape-a-loeil.png";
import OstinLogo from "../assets/customer-logos/ostin.png";
import InfiknitLogo from "../assets/customer-logos/infiknit.png";
import PrenatalLogo from "../assets/customer-logos/prenatal.png";
import DanJohnLogo from "../assets/customer-logos/dan-john.png";
import FransaLogo from "../assets/customer-logos/fransa.png";
import FashionNovaLogo from "../assets/customer-logos/fashion-nova.png";
import KaffeLogo from "../assets/customer-logos/kaffe.png";
import CreamLogo from "../assets/customer-logos/cream.png";

const Home = () => {
  return (
    <div className="flex flex-col gap-12">
      <HomeFirst />
      <Hero2 />
      <div>
        <WhyChooseUs />
        <div className="py-5 bg-white">
          <OurCustomers
            title="Our Customers"
            imageSet={OurCustomersHomeImages}
          />
        </div>
        <Products />
      </div>
      <Achievements />
    </div>
  );
};

export default Home;

export const OurCustomersHomeImages = [
  [
    VertbaudetLogo,
    SfreaLogo,
    AldiLogo,
    MangoLogo,
    GemoLogo,
    IdentityLogo,
    InterSunLogo,
  ],
  [NewLookLogo, LaHalleLogo, BelBoLogo, SportsGroupDenmarkLogo, ChiccoLogo],
  [SergentMajorLogo, TapeALoeilLogo, OstinLogo, InfiknitLogo, PrenatalLogo],
  [DanJohnLogo, FransaLogo, FashionNovaLogo, KaffeLogo, CreamLogo],
  // [
  //   `${medialUrl}/brands/vertbaudet.png`,
  //   `${medialUrl}/brands/sfrea.png`,
  //   `${medialUrl}/brands/aldi.png`,
  //   `${medialUrl}/brands/mango.png`,
  //   `${medialUrl}/brands/gemo.png`,
  //   `${medialUrl}/brands/identity.png`,
  //   `${medialUrl}/brands/inter_sun.png`,
  // ],
  // [
  //   `${medialUrl}/brands/mew_look.png`,
  //   `${medialUrl}/brands/la_halle.png`,
  //   `${medialUrl}/brands/bel_bo.png`,
  //   `${medialUrl}/brands/sport_group_denmark.png`,
  //   `${medialUrl}/brands/Chicco.png`,
  // ],
  // [
  //   `${medialUrl}/brands/sergent_major.png`,
  //   `${medialUrl}/brands/tape_a_Loeil.png`,
  //   `${medialUrl}/brands/ostin.png`,
  //   `${medialUrl}/brands/infiknit.png`,
  //   `${medialUrl}/brands/prenatal.png`,
  // ],
  // [
  //   `${medialUrl}/brands/dan_hohn.png`,
  //   `${medialUrl}/brands/fransa.png`,
  //   `${medialUrl}/brands/fashion_nova.png`,
  //   `${medialUrl}/brands/kaffe.png`,
  //   `${medialUrl}/brands/creame.png`,
  // ],
];
